export const preferredSourceUrl = () => {
  const site = new URL(process.env.REACT_APP_SITE_URL);
  const destination = new URL(process.env.REACT_APP_GOOGLE_PREFERRED_URL);
  if (site.protocol !== 'https:' || destination.protocol !== 'https:') throw new Error('Preferred Sources URLs must use HTTPS');
  destination.searchParams.set('q', site.origin);
  return destination.href;
};